import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[click]',
    standalone: false
})
export class CursorPointerDirective {

  @HostBinding('style.cursor') cursor: string = 'pointer';

}
